import instance from 'utils/axios/instance.axios';
import { PROJECT_DEADLINE_EXTENSIONS } from './_constant';

export const getAllByProjectId = (projectId) =>
  instance.get(PROJECT_DEADLINE_EXTENSIONS.GET_ALL_BY_PROJECT_ID(projectId));

export const getById = (id) => instance.get(PROJECT_DEADLINE_EXTENSIONS.GET_BY_ID(id));

export const createProjectDeadlineExtensions = (body = {}) =>
  instance.post(PROJECT_DEADLINE_EXTENSIONS.CREATE, body);

export const uploadExtendFile = ({ id, body = {} }) =>
  instance.post(PROJECT_DEADLINE_EXTENSIONS.UPLOAD_EXTEND_FILE(id), body);

export const updateExtendFile = (body = {}) =>
  instance.patch(PROJECT_DEADLINE_EXTENSIONS.UPLOAD_EXTEND_FILE, body);

export const updateProjectDeadlineExtensions = ({ id, body = {} }) =>
  instance.patch(PROJECT_DEADLINE_EXTENSIONS.UPDATE(id), body);

export const deleteProjectDeadlineExtensions = (id) =>
  instance.delete(PROJECT_DEADLINE_EXTENSIONS.DELETE(id));

export const submitProjectDeadlineExtensions = (id) =>
  instance.patch(PROJECT_DEADLINE_EXTENSIONS.SUBMIT(id));

export const deleteExtendFile = ({ id, body = {} }) =>
  instance.delete(PROJECT_DEADLINE_EXTENSIONS.DELETE_EXTEND_FILE(id), {
    data: body,
  });

export const downloadProjectDeadlineExtensionsDocxFile = (id) =>
  instance.get(PROJECT_DEADLINE_EXTENSIONS.DOWNLOAD_DOCX_FILE(id), { responseType: 'blob' });

export const DOWNLOAD_DOCX_TEMPLATE = ({ projectId }) =>
  instance.post(
    PROJECT_DEADLINE_EXTENSIONS.DOWNLOAD_DOCX_TEMPLATE,
    { projectId },
    { responseType: 'blob' }
  );

export const downloadProjectDeadlineExtensionsPdfFile = (id) =>
  instance.get(PROJECT_DEADLINE_EXTENSIONS.DOWNLOAD_PDF_FILE(id), { responseType: 'blob' });

export const DOWNLOAD_PDF_TEMPLATE = ({ projectId }) =>
  instance.post(
    PROJECT_DEADLINE_EXTENSIONS.DOWNLOAD_PDF_TEMPLATE,
    { projectId },
    { responseType: 'blob' }
  );

export const downloadProjectDeadlineFile = ({ path, id }) =>
  instance.post(PROJECT_DEADLINE_EXTENSIONS.DOWNLOAD_FILE, { path, id }, { responseType: 'blob' });
